'use client';

import { SearchDrawer } from '@eliadmin/core/src/components/header/search-bar/search-drawer';
import { useMobileSearch } from '@eliadmin/core/src/components/header/mobile-search';
import { useRef } from 'react';
import type { ButtonProps } from '@eliadmin/core/src/components/ui/button';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { useSystemLabels } from '@eliadmin/core/src/hooks/use-system-labels';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { FiSearch } from 'react-icons/fi';

// Brand-specific trigger only. Dialog, queries, pricing and result rendering live in core.
export type SearchButtonProps = Omit<ButtonProps, 'onClick' | 'className'> & {
  className?: {
    root?: string;
    icon?: string;
  };
};

export function SearchButton(props: SearchButtonProps) {
  const { className, ...buttonProps } = props;
  const systemLabels = useSystemLabels();
  const sharedOpen = useMobileSearch((s) => s.isOpen);
  const toggle = useMobileSearch((s) => s.toggle);
  const sharedOpenRef = useRef(sharedOpen);
  sharedOpenRef.current = sharedOpen;
  const notifyOpen = (next: boolean) => {
    if (sharedOpenRef.current === next) return;
    sharedOpenRef.current = next;
    toggle();
  };
  return (
    <SearchDrawer
      onOpenChange={notifyOpen}
      trigger={
        <Button
          {...buttonProps}
          type="button"
          className={cn(
            'text-primary-foreground hover:text-primary',
            'ea-search-button',
            className?.root,
          )}
          size="icon"
          aria-label={systemLabels('search')}
          aria-haspopup="dialog"
        >
          <FiSearch className={cn('h-5 w-5', 'ea-search-button__icon', className?.icon)} />
        </Button>
      }
    />
  );
}
